import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IGlobeViewFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  version?: number | null
  projectId: any
  name: string
  altitude?: number | null
  pitch?: number | null
  zoom?: number | null
  filledImage?: string | null
  bearing?: number | null
  isOrientationLocked?: boolean | null
  mapFiles?: Array<{
    entityId: any
    entityType: Types.MapFileType
  } | null> | null
  bounds?: {
    ne?: { lat: number; lng: number } | null
    sw?: { lat: number; lng: number } | null
  } | null
  center?: { lat: number; lng: number } | null
  geoCorners?: Array<{ latitude: number; longitude: number } | null> | null
  style?: {
    mapType: Types.GlobeViewMapType
    isThreeDEnabled: boolean
    isTrafficEnabled: boolean
    isTerrainEnabled: boolean
    shouldHideLabels: boolean
    isZoomScalingEnabled: boolean
    isLabelOverlapEnabled: boolean
    shouldHideWorkflowPinLabels: boolean
  } | null
}

export type IGlobeViewItemsFieldsFragment = {
  id?: any | null
  sitemapItemId?: any | null
  globeViewId?: any | null
  projectId: any
  isHidden?: boolean | null
  icon?: { isHidden?: boolean | null } | null
  label?: {
    fontSize: number
    isHidden?: boolean | null
    isTextBoxDisplayed: boolean
    color?: string | null
  } | null
  shape?:
    | {
        fillColor?: string | null
        fillOpacity: number
        lineColor?: string | null
        lineWidth: number
        type?: string | null
        isDisplayed?: boolean | null
      }
    | {
        arrowPosition?: Types.SitemapLineArrowPosition | null
        isClosed: boolean
        fillColor?: string | null
        fillOpacity: number
        lineColor?: string | null
        lineWidth: number
        type?: string | null
        isDisplayed?: boolean | null
      }
    | {
        fillColor?: string | null
        fillOpacity: number
        lineColor?: string | null
        lineWidth: number
        type?: string | null
        isDisplayed?: boolean | null
      }
    | null
}

export type IGlobeViewsByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGlobeViewsByProjectIdQuery = {
  globeViews?: {
    data: Array<{
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
      projectId: any
      name: string
      altitude?: number | null
      pitch?: number | null
      zoom?: number | null
      filledImage?: string | null
      bearing?: number | null
      isOrientationLocked?: boolean | null
      items?: Array<{
        id?: any | null
        sitemapItemId?: any | null
        globeViewId?: any | null
        projectId: any
        isHidden?: boolean | null
        icon?: { isHidden?: boolean | null } | null
        label?: {
          fontSize: number
          isHidden?: boolean | null
          isTextBoxDisplayed: boolean
          color?: string | null
        } | null
        shape?:
          | {
              fillColor?: string | null
              fillOpacity: number
              lineColor?: string | null
              lineWidth: number
              type?: string | null
              isDisplayed?: boolean | null
            }
          | {
              arrowPosition?: Types.SitemapLineArrowPosition | null
              isClosed: boolean
              fillColor?: string | null
              fillOpacity: number
              lineColor?: string | null
              lineWidth: number
              type?: string | null
              isDisplayed?: boolean | null
            }
          | {
              fillColor?: string | null
              fillOpacity: number
              lineColor?: string | null
              lineWidth: number
              type?: string | null
              isDisplayed?: boolean | null
            }
          | null
      } | null> | null
      mapFiles?: Array<{
        entityId: any
        entityType: Types.MapFileType
      } | null> | null
      bounds?: {
        ne?: { lat: number; lng: number } | null
        sw?: { lat: number; lng: number } | null
      } | null
      center?: { lat: number; lng: number } | null
      geoCorners?: Array<{ latitude: number; longitude: number } | null> | null
      style?: {
        mapType: Types.GlobeViewMapType
        isThreeDEnabled: boolean
        isTrafficEnabled: boolean
        isTerrainEnabled: boolean
        shouldHideLabels: boolean
        isZoomScalingEnabled: boolean
        isLabelOverlapEnabled: boolean
        shouldHideWorkflowPinLabels: boolean
      } | null
    }>
  } | null
}

export type IListenGlobeViewsByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenGlobeViewsByProjectIdSubscription = {
  globeView?: {
    id?: any | null
    item?: {
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      version?: number | null
      projectId: any
      name: string
      altitude?: number | null
      pitch?: number | null
      zoom?: number | null
      filledImage?: string | null
      bearing?: number | null
      isOrientationLocked?: boolean | null
      mapFiles?: Array<{
        entityId: any
        entityType: Types.MapFileType
      } | null> | null
      bounds?: {
        ne?: { lat: number; lng: number } | null
        sw?: { lat: number; lng: number } | null
      } | null
      center?: { lat: number; lng: number } | null
      geoCorners?: Array<{ latitude: number; longitude: number } | null> | null
      style?: {
        mapType: Types.GlobeViewMapType
        isThreeDEnabled: boolean
        isTrafficEnabled: boolean
        isTerrainEnabled: boolean
        shouldHideLabels: boolean
        isZoomScalingEnabled: boolean
        isLabelOverlapEnabled: boolean
        shouldHideWorkflowPinLabels: boolean
      } | null
    } | null
  } | null
}

export type IListenGlobeViewItemsDataByProjectIdSubscriptionVariables =
  Types.Exact<{
    projectId: Types.Scalars['ObjectId']['input']
  }>

export type IListenGlobeViewItemsDataByProjectIdSubscription = {
  globeViewSpecificItemData?: {
    id?: any | null
    item?: {
      id?: any | null
      sitemapItemId?: any | null
      globeViewId?: any | null
      projectId: any
      isHidden?: boolean | null
      icon?: { isHidden?: boolean | null } | null
      label?: {
        fontSize: number
        isHidden?: boolean | null
        isTextBoxDisplayed: boolean
        color?: string | null
      } | null
      shape?:
        | {
            fillColor?: string | null
            fillOpacity: number
            lineColor?: string | null
            lineWidth: number
            type?: string | null
            isDisplayed?: boolean | null
          }
        | {
            arrowPosition?: Types.SitemapLineArrowPosition | null
            isClosed: boolean
            fillColor?: string | null
            fillOpacity: number
            lineColor?: string | null
            lineWidth: number
            type?: string | null
            isDisplayed?: boolean | null
          }
        | {
            fillColor?: string | null
            fillOpacity: number
            lineColor?: string | null
            lineWidth: number
            type?: string | null
            isDisplayed?: boolean | null
          }
        | null
    } | null
  } | null
}

export type ISaveGlobeViewMutationVariables = Types.Exact<{
  globeView: Types.IGlobeViewInput
}>

export type ISaveGlobeViewMutation = {
  saveGlobeView?: { id?: any | null } | null
}

export type ISaveGlobeViewStyleMutationVariables = Types.Exact<{
  style: Types.IGlobeViewStyleInput
  globeViewId: Types.Scalars['ObjectId']['input']
}>

export type ISaveGlobeViewStyleMutation = {
  saveGlobeViewStyle?: { id?: any | null } | null
}

export type ISaveGlobeViewSpecificItemDataMutationVariables = Types.Exact<{
  polylines?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.IGlobeViewSpecificItemDataPolylineInput>>
    | Types.InputMaybe<Types.IGlobeViewSpecificItemDataPolylineInput>
  >
  rectangles?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.IGlobeViewSpecificItemDataRectangleInput>>
    | Types.InputMaybe<Types.IGlobeViewSpecificItemDataRectangleInput>
  >
  circles?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.IGlobeViewSpecificItemDataCircleInput>>
    | Types.InputMaybe<Types.IGlobeViewSpecificItemDataCircleInput>
  >
}>

export type ISaveGlobeViewSpecificItemDataMutation = {
  saveGlobeViewSpecificItemData?: Array<{ id?: any | null } | null> | null
}

export type IDeleteGlobeViewSpecificItemDataMutationVariables = Types.Exact<{
  globeViewItemId: Types.Scalars['ObjectId']['input']
}>

export type IDeleteGlobeViewSpecificItemDataMutation = {
  deleteGlobeViewSpecificItemData?: boolean | null
}

export type IDeleteGlobeViewMutationVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteGlobeViewMutation = { deleteGlobeView?: boolean | null }

export const GlobeViewFieldsFragmentDoc = gql`
  fragment GlobeViewFields on GlobeView {
    id
    createdAt
    updatedAt
    version
    projectId
    name
    altitude
    pitch
    zoom
    filledImage
    bearing
    mapFiles {
      entityId
      entityType
    }
    bounds {
      ne {
        lat
        lng
      }
      sw {
        lat
        lng
      }
    }
    center {
      lat
      lng
    }
    geoCorners {
      latitude
      longitude
    }
    isOrientationLocked
    style {
      mapType
      isThreeDEnabled
      isTrafficEnabled
      isTerrainEnabled
      shouldHideLabels
      isZoomScalingEnabled
      isLabelOverlapEnabled
      shouldHideWorkflowPinLabels
    }
  }
`
export const GlobeViewItemsFieldsFragmentDoc = gql`
  fragment GlobeViewItemsFields on GlobeViewSpecificItemData {
    id
    sitemapItemId
    globeViewId
    projectId
    isHidden
    icon {
      isHidden
    }
    label {
      fontSize
      isHidden
      isTextBoxDisplayed
      color
    }
    shape {
      fillColor
      fillOpacity
      lineColor
      lineWidth
      type
      isDisplayed
      ... on GlobeViewPolyline {
        arrowPosition
        isClosed
      }
    }
  }
`
export const GlobeViewsByProjectIdDocument = gql`
  query GlobeViewsByProjectId($projectId: ObjectId!) {
    globeViews(projectId: $projectId, limit: 1000000) {
      data {
        ...GlobeViewFields
        items {
          ...GlobeViewItemsFields
        }
      }
    }
  }
  ${GlobeViewFieldsFragmentDoc}
  ${GlobeViewItemsFieldsFragmentDoc}
`

/**
 * __useGlobeViewsByProjectIdQuery__
 *
 * To run a query within a React component, call `useGlobeViewsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobeViewsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobeViewsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGlobeViewsByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGlobeViewsByProjectIdQuery,
    IGlobeViewsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGlobeViewsByProjectIdQuery,
    IGlobeViewsByProjectIdQueryVariables
  >(GlobeViewsByProjectIdDocument, options)
}
export function useGlobeViewsByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGlobeViewsByProjectIdQuery,
    IGlobeViewsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGlobeViewsByProjectIdQuery,
    IGlobeViewsByProjectIdQueryVariables
  >(GlobeViewsByProjectIdDocument, options)
}
export type GlobeViewsByProjectIdQueryHookResult = ReturnType<
  typeof useGlobeViewsByProjectIdQuery
>
export type GlobeViewsByProjectIdLazyQueryHookResult = ReturnType<
  typeof useGlobeViewsByProjectIdLazyQuery
>
export type GlobeViewsByProjectIdQueryResult = Apollo.QueryResult<
  IGlobeViewsByProjectIdQuery,
  IGlobeViewsByProjectIdQueryVariables
>
export const ListenGlobeViewsByProjectIdDocument = gql`
  subscription ListenGlobeViewsByProjectId($projectId: ObjectId!) {
    globeView(projectId: $projectId) {
      id
      item {
        ...GlobeViewFields
      }
    }
  }
  ${GlobeViewFieldsFragmentDoc}
`

/**
 * __useListenGlobeViewsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenGlobeViewsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenGlobeViewsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenGlobeViewsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenGlobeViewsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenGlobeViewsByProjectIdSubscription,
    IListenGlobeViewsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenGlobeViewsByProjectIdSubscription,
    IListenGlobeViewsByProjectIdSubscriptionVariables
  >(ListenGlobeViewsByProjectIdDocument, options)
}
export type ListenGlobeViewsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenGlobeViewsByProjectIdSubscription
>
export type ListenGlobeViewsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenGlobeViewsByProjectIdSubscription>
export const ListenGlobeViewItemsDataByProjectIdDocument = gql`
  subscription ListenGlobeViewItemsDataByProjectId($projectId: ObjectId!) {
    globeViewSpecificItemData(projectId: $projectId) {
      id
      item {
        ...GlobeViewItemsFields
      }
    }
  }
  ${GlobeViewItemsFieldsFragmentDoc}
`

/**
 * __useListenGlobeViewItemsDataByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenGlobeViewItemsDataByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenGlobeViewItemsDataByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenGlobeViewItemsDataByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenGlobeViewItemsDataByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenGlobeViewItemsDataByProjectIdSubscription,
    IListenGlobeViewItemsDataByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenGlobeViewItemsDataByProjectIdSubscription,
    IListenGlobeViewItemsDataByProjectIdSubscriptionVariables
  >(ListenGlobeViewItemsDataByProjectIdDocument, options)
}
export type ListenGlobeViewItemsDataByProjectIdSubscriptionHookResult =
  ReturnType<typeof useListenGlobeViewItemsDataByProjectIdSubscription>
export type ListenGlobeViewItemsDataByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenGlobeViewItemsDataByProjectIdSubscription>
export const SaveGlobeViewDocument = gql`
  mutation SaveGlobeView($globeView: GlobeViewInput!) {
    saveGlobeView(globeView: $globeView) {
      id
    }
  }
`
export type ISaveGlobeViewMutationFn = Apollo.MutationFunction<
  ISaveGlobeViewMutation,
  ISaveGlobeViewMutationVariables
>

/**
 * __useSaveGlobeViewMutation__
 *
 * To run a mutation, you first call `useSaveGlobeViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobeViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobeViewMutation, { data, loading, error }] = useSaveGlobeViewMutation({
 *   variables: {
 *      globeView: // value for 'globeView'
 *   },
 * });
 */
export function useSaveGlobeViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveGlobeViewMutation,
    ISaveGlobeViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveGlobeViewMutation,
    ISaveGlobeViewMutationVariables
  >(SaveGlobeViewDocument, options)
}
export type SaveGlobeViewMutationHookResult = ReturnType<
  typeof useSaveGlobeViewMutation
>
export type SaveGlobeViewMutationResult =
  Apollo.MutationResult<ISaveGlobeViewMutation>
export type SaveGlobeViewMutationOptions = Apollo.BaseMutationOptions<
  ISaveGlobeViewMutation,
  ISaveGlobeViewMutationVariables
>
export const SaveGlobeViewStyleDocument = gql`
  mutation SaveGlobeViewStyle(
    $style: GlobeViewStyleInput!
    $globeViewId: ObjectId!
  ) {
    saveGlobeViewStyle(style: $style, globeViewId: $globeViewId) {
      id
    }
  }
`
export type ISaveGlobeViewStyleMutationFn = Apollo.MutationFunction<
  ISaveGlobeViewStyleMutation,
  ISaveGlobeViewStyleMutationVariables
>

/**
 * __useSaveGlobeViewStyleMutation__
 *
 * To run a mutation, you first call `useSaveGlobeViewStyleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobeViewStyleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobeViewStyleMutation, { data, loading, error }] = useSaveGlobeViewStyleMutation({
 *   variables: {
 *      style: // value for 'style'
 *      globeViewId: // value for 'globeViewId'
 *   },
 * });
 */
export function useSaveGlobeViewStyleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveGlobeViewStyleMutation,
    ISaveGlobeViewStyleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveGlobeViewStyleMutation,
    ISaveGlobeViewStyleMutationVariables
  >(SaveGlobeViewStyleDocument, options)
}
export type SaveGlobeViewStyleMutationHookResult = ReturnType<
  typeof useSaveGlobeViewStyleMutation
>
export type SaveGlobeViewStyleMutationResult =
  Apollo.MutationResult<ISaveGlobeViewStyleMutation>
export type SaveGlobeViewStyleMutationOptions = Apollo.BaseMutationOptions<
  ISaveGlobeViewStyleMutation,
  ISaveGlobeViewStyleMutationVariables
>
export const SaveGlobeViewSpecificItemDataDocument = gql`
  mutation SaveGlobeViewSpecificItemData(
    $polylines: [GlobeViewSpecificItemDataPolylineInput]
    $rectangles: [GlobeViewSpecificItemDataRectangleInput]
    $circles: [GlobeViewSpecificItemDataCircleInput]
  ) {
    saveGlobeViewSpecificItemData(
      polylines: $polylines
      rectangles: $rectangles
      circles: $circles
    ) {
      id
    }
  }
`
export type ISaveGlobeViewSpecificItemDataMutationFn = Apollo.MutationFunction<
  ISaveGlobeViewSpecificItemDataMutation,
  ISaveGlobeViewSpecificItemDataMutationVariables
>

/**
 * __useSaveGlobeViewSpecificItemDataMutation__
 *
 * To run a mutation, you first call `useSaveGlobeViewSpecificItemDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGlobeViewSpecificItemDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGlobeViewSpecificItemDataMutation, { data, loading, error }] = useSaveGlobeViewSpecificItemDataMutation({
 *   variables: {
 *      polylines: // value for 'polylines'
 *      rectangles: // value for 'rectangles'
 *      circles: // value for 'circles'
 *   },
 * });
 */
export function useSaveGlobeViewSpecificItemDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveGlobeViewSpecificItemDataMutation,
    ISaveGlobeViewSpecificItemDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveGlobeViewSpecificItemDataMutation,
    ISaveGlobeViewSpecificItemDataMutationVariables
  >(SaveGlobeViewSpecificItemDataDocument, options)
}
export type SaveGlobeViewSpecificItemDataMutationHookResult = ReturnType<
  typeof useSaveGlobeViewSpecificItemDataMutation
>
export type SaveGlobeViewSpecificItemDataMutationResult =
  Apollo.MutationResult<ISaveGlobeViewSpecificItemDataMutation>
export type SaveGlobeViewSpecificItemDataMutationOptions =
  Apollo.BaseMutationOptions<
    ISaveGlobeViewSpecificItemDataMutation,
    ISaveGlobeViewSpecificItemDataMutationVariables
  >
export const DeleteGlobeViewSpecificItemDataDocument = gql`
  mutation DeleteGlobeViewSpecificItemData($globeViewItemId: ObjectId!) {
    deleteGlobeViewSpecificItemData(id: $globeViewItemId)
  }
`
export type IDeleteGlobeViewSpecificItemDataMutationFn =
  Apollo.MutationFunction<
    IDeleteGlobeViewSpecificItemDataMutation,
    IDeleteGlobeViewSpecificItemDataMutationVariables
  >

/**
 * __useDeleteGlobeViewSpecificItemDataMutation__
 *
 * To run a mutation, you first call `useDeleteGlobeViewSpecificItemDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobeViewSpecificItemDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobeViewSpecificItemDataMutation, { data, loading, error }] = useDeleteGlobeViewSpecificItemDataMutation({
 *   variables: {
 *      globeViewItemId: // value for 'globeViewItemId'
 *   },
 * });
 */
export function useDeleteGlobeViewSpecificItemDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteGlobeViewSpecificItemDataMutation,
    IDeleteGlobeViewSpecificItemDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteGlobeViewSpecificItemDataMutation,
    IDeleteGlobeViewSpecificItemDataMutationVariables
  >(DeleteGlobeViewSpecificItemDataDocument, options)
}
export type DeleteGlobeViewSpecificItemDataMutationHookResult = ReturnType<
  typeof useDeleteGlobeViewSpecificItemDataMutation
>
export type DeleteGlobeViewSpecificItemDataMutationResult =
  Apollo.MutationResult<IDeleteGlobeViewSpecificItemDataMutation>
export type DeleteGlobeViewSpecificItemDataMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteGlobeViewSpecificItemDataMutation,
    IDeleteGlobeViewSpecificItemDataMutationVariables
  >
export const DeleteGlobeViewDocument = gql`
  mutation DeleteGlobeView($id: ObjectId!) {
    deleteGlobeView(id: $id)
  }
`
export type IDeleteGlobeViewMutationFn = Apollo.MutationFunction<
  IDeleteGlobeViewMutation,
  IDeleteGlobeViewMutationVariables
>

/**
 * __useDeleteGlobeViewMutation__
 *
 * To run a mutation, you first call `useDeleteGlobeViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobeViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobeViewMutation, { data, loading, error }] = useDeleteGlobeViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlobeViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteGlobeViewMutation,
    IDeleteGlobeViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteGlobeViewMutation,
    IDeleteGlobeViewMutationVariables
  >(DeleteGlobeViewDocument, options)
}
export type DeleteGlobeViewMutationHookResult = ReturnType<
  typeof useDeleteGlobeViewMutation
>
export type DeleteGlobeViewMutationResult =
  Apollo.MutationResult<IDeleteGlobeViewMutation>
export type DeleteGlobeViewMutationOptions = Apollo.BaseMutationOptions<
  IDeleteGlobeViewMutation,
  IDeleteGlobeViewMutationVariables
>
